import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { AxiosError, isAxiosError } from 'axios';

import * as Sentry from '@sentry/react';
import { ErrorEvent, EventHint } from '@sentry/react';

const findAxiosError = (error: unknown): AxiosError | undefined => {
  if (isAxiosError(error)) return error;
  if (error instanceof Error && error.cause) return findAxiosError(error.cause);
  return undefined;
};

const handleSentryBeforeSend = (event: ErrorEvent, hint: EventHint) => {
  const axiosError = findAxiosError(hint.originalException);
  if (!axiosError) return event;

  // axios interceptor에서 처리된 에러는 Sentry에 전송하지 않음
  if ((axiosError as AxiosError)._isHandled) return null;

  event.contexts = {
    ...event.contexts,
    Axios: { Response: axiosError.response }
  };

  return event;
};

export const initSentry = ({ dsn, origin, release }: { dsn: string; origin: string; release: string }) => {
  Sentry.init({
    dsn,
    release,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration()
    ],
    beforeSend: handleSentryBeforeSend
  });

  Sentry.setTags({ origin, release });
};

export const setSentryLevelToWarning = () => {
  Sentry.getCurrentScope().setLevel('warning');
};
